<template>
  <ion-content id="app" class="ion-padding">
    <h1>Neuen Link erstellen</h1>
    <LinkFields modus="new" :box="box"/>
  </ion-content>
</template>

<script>
  import LinkFields from "../../components/link/LinkFields.vue";

  export default {
    name: "LinkNew",
    components: {LinkFields},
    data(){
      return {
        box: this.$route.params.box
      }
    },
  };
</script>

<style>

</style>
